import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { isLoggedIn } from './utils/general'
import SideMenu from 'components/SideMenu/SideMenu'

import NoMatch from './pages/NoMatch'
import Login from './pages/login/Login'
import Home from './pages/home/Home'
import { Administradores, Usuarios } from './pages/Usuarios'
import { Inicio, Historia, Contacto } from './pages/modificaciones'
import { TestComponent } from 'pages/test'
import Noticias from 'pages/noticias/Noticias'
import { MiembrosDirectiva } from 'pages/miembrosDirectiva'
import { Comites } from 'pages/comites'
import { Socios } from 'pages/socios'
import ComunicadosPrensa from 'pages/comunicados-prensa/ComunicadosPrensa'
import CapacitacionesEventos from 'pages/capacitaciones-eventos/CapacitacionesEventos'
import Regulaciones from 'pages/regulaciones/Regulaciones'
import PropiedadesIntelectuales from 'pages/propiedades-intelectuales/PropiedadesIntelectuales'
import { InformacionesSector } from 'pages/informaciones-sector'
import Patentes from 'pages/patentes/Patentes'
import ComisionDirectiva from 'pages/modificaciones/ComisionDirectiva'
import { CargosDirectiva } from 'pages/CargosDirectiva'

function App() {
	// login state
	const [loggedIn, setLoggedIn] = useState(
		isLoggedIn()
	);

	const [menuExpanded, setMenuExpanded] = useState(true)
	
	if (menuExpanded) {
		document.body.classList.add('menu-expanded')
	} else {
		document.body.classList.remove('menu-expanded')
	}

	useEffect(() => {
		setLoggedIn(isLoggedIn())
	}, []);

	// render
	return (
		<>
			<ToastContainer />
			<Router basename={process.env.PUBLIC_URL}>
					<Route render={({ location, history }) => (
						<>
							<Route exact path="/login" component={props => <Login setLoggedIn={(setLoggedIn)} history={history} />} />
							{loggedIn && <SideMenu location={location} history={history} setLoggedIn={setLoggedIn} menuExpanded={menuExpanded} setMenuExpanded={setMenuExpanded} />}
							<main className={menuExpanded ? 'section expanded' : 'section'}>
								<Switch>
									<Route exact path="/" render={() => {
										return (
											<Redirect to="/inicio" /> 
										)
									}}/>
									<Route exact path="/inicio">
										<Home />
									</Route>
									<Route exact path="/usuarios/administradores">
										<Administradores />
									</Route>
									<Route exact path="/usuarios/clientes">
										<Usuarios />
									</Route>
									<Route exact path="/comision-directiva" component={CargosDirectiva} />
									<Route exact path="/comites" component={Comites} />
									<Route exact path="/asociados" component={Socios} />
									<Route exact path="/patentes" component={Patentes} />
									<Route exact path="/modificaciones/inicio">
										<Inicio />
									</Route>
									<Route exact path="/modificaciones/comision-directiva">
										<ComisionDirectiva />
									</Route>
									<Route exact path="/modificaciones/historia">
										<Historia />
									</Route>
									<Route exact path="/modificaciones/contacto">
										<Contacto />
									</Route>
									<Route exact path="/comunicados">
										<ComunicadosPrensa />
									</Route>
									<Route exact path="/capacitaciones-eventos">
										<CapacitacionesEventos />
									</Route>
									<Route exact path="/regulaciones-sanitarias">
										<Regulaciones />
									</Route>
									<Route exact path="/propiedad-intelectual">
										<PropiedadesIntelectuales />
									</Route>
									<Route exact path="/informacion-sector">
										<InformacionesSector />
									</Route>
									<Route exact path="/test">
										<TestComponent />
									</Route>
									{loggedIn && <Route path="*" component={props => <NoMatch />} />}
								</Switch>
							</main>
						</>
					)}
					/>
					{!loggedIn && <Redirect to="/login" />}
			</Router>
		</>
	);
}

export default App
